import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingService } from '../../../loading/loading.service';
import { HighwaysService } from 'src/app/modules/services/highways/highways.service';
import { SegmentsService } from 'src/app/modules/services/segments/segments.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { catchError, debounceTime, distinctUntilChanged, finalize, of, switchMap } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { AlertComponent } from '../../../alert/alert.component';
import { SegmentModalComponent } from '../modal/segment-modal/segment-modal.component';
import { ModalComponent } from '../../../modal/modal.component';
import { segmentI } from 'src/app/modules/@types/segmentsI.interface';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';
import { ModalController } from '@ionic/angular';
import { ModalHistoricSegmentComponent } from 'src/app/modules/shared/modals/modal-historic-segment/modal-historic-segment.component';


@Component({
  selector: 'app-segments-table',
  templateUrl: './segments-table.component.html',
  styleUrls: ['./segments-table.component.scss']
})
export class SegmentsTableComponent implements OnInit {
  @Output() segmentEventAtt = new EventEmitter<void>();
  @Input() dataSourceSegments = new MatTableDataSource<any>([

  ]);
  @Input() highWay: any
  @Input() contractId: any

  params = {

  }
  buttonInclusaoDisabled: boolean = false;
  buttonExclusaoDisabled: boolean = false;
  buttonEdicaoDisabled: boolean = false;
  pageSizeSegment: number = 10;
  pageSizeOptionsSegment: number[] = [10, 30, 50, 100, 500];
  nameOrDescription = '';
  pageIndexSegment: number = 0;
  totalPagesSegment: number = 1;
  totalElementsSegment: number = 1;
  displayedColumns: string[] = [

    'segment',
    'description',
    'init',
    'final',
    'extension',
    'actions',
  ];
  sortState: any = { sortProperty: 'criadoEm', sortDirection: 'desc' };
  searchControl = new FormControl();
  extensionTotal: number = 0;
  segmentsArray: any[] = [];
  @ViewChild('paginatorSegment') paginator !: MatPaginator;
  isEditMode: any;
  screenWidth: number = 0;
  screenHeight: number = 0;

  constructor(
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    private highWayService: HighwaysService,
    private segmentService: SegmentsService,
    private dialogRef: MatDialogRef<SegmentsTableComponent>,
    private cdr: ChangeDetectorRef,
    private modalCtrl: ModalController,
    @Inject(MAT_DIALOG_DATA) public uploadData: any,
  ) {

  }
  ngOnInit(): void {
    this.contractId = this.uploadData.contract_id;
    this.highWay = this.uploadData.highway;
    this.isEditMode = this.uploadData.isEditMode;
    this.buttonEdicaoDisabled =  this.uploadData.buttonEdicaoDisabled;
    this.buttonExclusaoDisabled =  this.uploadData.buttonExclusaoDisabled;
    this.buttonInclusaoDisabled =  this.uploadData.buttonInclusaoDisabled;
    this.getSements()

    this.getScreenDimensions();
    window.addEventListener('resize', this.getScreenDimensions.bind(this));

  }
  getScreenDimensions() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }
  onSortChange(sortProperty: 'name' | 'description' | 'initialKm' | 'finalKm' | 'extensionKm'): void {

    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {

      this.sortState.sortDirection = 'asc';
    }
    this.sortState.sortProperty = sortProperty;

    this.getSements()

  }
  addSegment() {

    let data = {
      isEditMode: false
    }
    const dialog = this.dialog.open(SegmentModalComponent, {
      panelClass: ['filter-panel'],
      data: data
    });

    dialog.afterClosed().subscribe({
      next: (res: any) => {
        if (res) {
          this.submit(res);
        }
      },
      error: (err: any) => {
        this.openSnackBar(err.error.message, 'error');

      }
    })
  }



  submit(data: any) {

    this.loadingService.showLoading()
    this.segmentService.vinculateSegmentToHighway(data, this.contractId, this.highWay?.id).pipe(
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe({
      next: (res: any) => {
        this.getSements()
        this.openSnackBar('Segmento adicionado com sucesso.', 'sucess');
      },
      error: (err: any) => {
        this.openSnackBar(err.error.message, 'error');
      }
    })
  }

  editSegment(segment: any) {

    let data = {
      isEditMode: true,
      segment: segment
    }
    const dialog = this.dialog.open(SegmentModalComponent, {
      panelClass: ['filter-panel'],
      data: data
    });

    dialog.afterClosed().subscribe({
      next: (res: any) => {



        if(res){
          this.loadingService.showLoading()
          this.segmentService.editSegment(res, this.contractId, this.highWay?.id, segment.id).pipe(
            finalize(() => {
              this.loadingService.hideLoading();
            })
          ).subscribe({
            next: (res: any) => {
              this.getSements()
              this.openSnackBar('Segmento editado com sucesso.', 'sucess');
            },
            error: (err: any) => {
              this.openSnackBar(err.error.message, 'error');
            }
          })
        }

      },
      error: (err: any) => {
        this.openSnackBar(err.error.message, 'error');
      }
    })
  }

  pageChangeEventSegment(event: PageEvent) {
    if (this.pageSizeSegment !== event.pageSize) {
      this.pageSizeSegment = event.pageSize;
      this.pageIndexSegment = 0;
      return this.getSements(0);
    }

    if (this.pageIndexSegment !== event.pageIndex) {
      this.getSements(event.pageIndex)
    }
  }

  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    if (filterValue.length >= 3 || filterValue.length === 0) {
      this.nameOrDescription = filterValue

      this.getSements()
    }

  }

  getSements(pageIndex: number = 0) {
    this.loadingService.showLoading()
    this.segmentService.getSegmentsHighways(pageIndex,
      this.pageSizeSegment,
      this.contractId,
      this.highWay?.id,
      this.sortState.sortDirection,
      this.sortState.sortProperty,
      this.nameOrDescription,
      this.nameOrDescription
    ).pipe(
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe({
      next: (res: any) => {
        const { content, pageSize, totalPages, totalElements, pageNumber } =
          res;
        this.dataSourceSegments.data = content

        const pageSizeChanged = this.pageSizeSegment !== pageSize;
        this.pageSizeSegment = pageSize;

        if (pageSizeChanged) {
          // Guarantees the paginator receives the new pageSize before bubble recalculation.
          this.cdr.detectChanges();
        }

        this.totalPagesSegment = totalPages;
        this.totalElementsSegment = totalElements;
        this.pageIndexSegment = pageNumber;
        this.extensionTotal = 0
        res.content.forEach((segment: segmentI) => {
          this.extensionTotal += segment.extensionKm
        });
      }, error: (err: any) => {

        this.dataSourceSegments.data = []
        if (err.error.message === 'Nenhum segmento encontrado.') {
          this.dataSourceSegments.data = []
        } else {
          this.openSnackBar(err.error.message, 'error');

        }

      }

    })
  }

  openDeleteDialog(id: string): void {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir este Segmento?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });
  }

  onDeleteModalConfirm(id: any): void {
    // this.loadingService.showLoading();
    this.segmentService.deleteSegment(id, this.contractId, this.highWay.id).pipe(
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe({
      next: (res: any) => {
        this.getSements()
        this.openSnackBar('Segmento excluido com sucesso.', 'sucess');
      },
      error: (err: any) => {
        this.openSnackBar(err.error.message, 'error');
      }
    })
  }

  back() {
    this.dialogRef.close()
  }

  async openDialogHistoricoSegmento(contractId: string, highwayId: string, segmentId: string,){


      let data = {
        type: 'segmento',
          id: contractId,
          highwayId: highwayId,
          segmentId: segmentId,
          fieldMappings: {
            id: 'Id',
            name: 'Segmento',
            extensionKm: 'Extensão(km)',
            initialKm: 'Início',
            finalKm: 'Final',
            description: 'Descrição'
          }

        }
        const dialog = this.dialog.open(ModalHistoricSegmentComponent, {
          panelClass: ['historic-panel'],
          data: data
        })

    // const data = {
    //   type: 'segmento',
    //   id: contractId,
    //   highwayId: highwayId,
    //   segmentId: segmentId,
    //   fieldMappings: {
    //     id: 'Id',
    //     name: 'Segmento',
    //     extensionKm: 'Extensão(km)',
    //     initialKm: 'Início',
    //     finalKm: 'Final',
    //     description: 'Descrição'
    //   }
    // }
    // const modal = await this.modalCtrl.create({
    //   component: ModalHistoricComponent,
    //   componentProps: {
    //     data: data,
    //     fieldMappings: data.fieldMappings,
    //   },
    // });

    // modal.present();
  }


}
